import type { TourListItem } from "@/api/tour";
import { stripHtml } from "@/utils/format";

interface TourCardProps {
  tour: TourListItem;
  isReplaceMode: boolean;
  onSelect: (id: number) => void;
}

export default function TourCard({ tour, isReplaceMode, onSelect }: TourCardProps) {
  return (
    <div
      className="bg-white rounded-2xl overflow-hidden cursor-pointer transition-all active:scale-[0.98]"
      style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
      onClick={() => onSelect(tour.id)}
    >
      {/* Image */}
      <div className="relative" style={{ height: 160 }}>
        <img src={tour.cover_image} alt={tour.title} className="w-full h-full object-cover object-top" />
        {/* 顶部标签压图保留（天数/目的地/成团人数） */}
        <div className="absolute top-3 left-3 flex gap-1.5">
          <span className="text-xs text-white px-2 py-0.5 rounded-full font-medium" style={{ background: "#F59E0B" }}>
            {tour.days_text}
          </span>
          <span className="text-xs text-white px-2 py-0.5 rounded-full" style={{ background: "rgba(0,0,0,0.4)" }}>
            {stripHtml(tour.destinations)}
          </span>
          <span className="text-xs text-white px-2 py-0.5 rounded-full" style={{ background: "#059669" }}>
            {tour.group_people}人成团
          </span>
        </div>
      </div>

      {/* Info：标题 + 景点 + 价格/库存，纵向阅读流 */}
      <div className="p-3">
        <div className="text-base font-bold text-gray-900 leading-snug line-clamp-2">{stripHtml(tour.title)}</div>
        {tour.attractions && (
          <div className="text-xs text-gray-500 leading-snug mt-2 line-clamp-2">{stripHtml(tour.attractions)}</div>
        )}
        <div className="flex items-center justify-between mt-2.5">
          <div className="flex items-center gap-2 text-xs text-gray-400">
            <span>库存{tour.stock}</span>
            <span className="w-px h-3 bg-gray-200" />
            <span>出发·{stripHtml(tour.departure_city)}</span>
          </div>
          <div className="flex items-baseline gap-0.5">
            <span className="text-xs text-gray-400">¥</span>
            <span className="font-bold" style={{ color: "#EF4444", fontSize: 18 }}>{tour.price}</span>
            <span className="text-xs text-gray-400">/人起</span>
          </div>
        </div>
      </div>
    </div>
  );
}
